namespace Portico.Models.Enterprise {

    export interface ITenant {
        id: number;
        name: string;

        programs: Program[];
    }

    export class Tenant implements ITenant {
        id: number;
        name: string;

        programs: Program[];

        constructor(obj?: ITenant) {
            this.id = null;
            this.name = '';

            this.programs = [];

			if (obj) {
				this.id = obj.id || null;
                this.name = obj.name || '';

                if (obj.programs) {
                    for (const program of obj.programs) {
                        this.programs.push(new Program(program));
                    }
                }
            }
        }
    }
}
